import { Box, List, Typography, useMediaQuery, useTheme } from '@mui/material';
import LoginRightListItem from './LoginRightListItem';
import { useTranslation } from '../../hooks/useTranslation';
// import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
function LoginRightContent(props) {
	const { t } = useTranslation();
	const theme = useTheme();
	const mobileScreen = useMediaQuery(theme.breakpoints.down('md'));
  const isDark = props.customDetails?.darkTheme === true || theme.palette.mode === 'dark';
	return (
		<>
			<Box width={'100%'}>
				<Typography
					sx={{
						textAlign: 'start',
						fontSize: mobileScreen ? '1rem' : '1.875rem',
						fontWeight: 700,
						mb: !mobileScreen ? '1.25rem' : '0.5rem',
						fontFamily: props?.customDetails?.fontFamily,
            color: props.customDetails?.primaryTextColor ?? (isDark ? '#fff' : '#000'),
					}}
				>
						 {t('login.infographic.title')}
				</Typography>
				<Typography
					sx={{
						textAlign: 'start',
						color: props.customDetails.primaryColor,
						fontSize: mobileScreen ? '1.5rem' : '2.75rem',
						fontWeight: 900,
						fontFamily: props?.customDetails?.fontFamily,
            color: props.customDetails?.primaryTextColor ?? (isDark ? '#fff' : props.customDetails.primaryColor),
					}}
				>
					{t('login.infographic.stepsTitle')}
				</Typography>
			</Box>
			<List>
				<LoginRightListItem
					number={1}
					text={t('login.infographic.step1')}
					{...props}
				/>
				<LoginRightListItem
					number={2}
					text={t('login.infographic.step2')}
					{...props}
				/>
				<LoginRightListItem
					number={3}
					text={t('login.infographic.step3')}
					{...props}
				/>
			</List>
		</>
	);
}

export default LoginRightContent;
